import firebase from 'firebase';
import _ from 'lodash';

import View from '../../../_components/view/view.js';
import userTpl from './user.tpl.html';
import './user.styles.less';

class UserView extends View {

	constructor (data, options) {
		super(userTpl, data, _.extend(options, {
				viewClass: 'user'
			})
		);
	}

	/*uiElements() {
		return _.extend(super.uiElements(), {
			playerImage: '.player-image',
			btnDelete: '.btn-delete',
			btnLinkPlayer: '.btn-link-player',
			btnUnlinkPlayer: '.btn-unlink-player'
		});
	}*/

	render(data) {
		super.render(data);

		/*if (this.data.userId) {
			this.ui.playerImage.removeClass('hidden');
		}*/
	}

	initializeEvents() {
		/*this.ui.btnDelete.click(() => this.deletePlayer());
		this.ui.btnLinkPlayer.click(() => this.linkPlayer());
		this.ui.btnUnlinkPlayer.click(() => this.unlinkPlayer());*/
	}

	/*deletePlayer() {
		new ConfirmModal(
			`Are you sure you want to delete the user?<br>
				This action <b>CANNOT</b> be undone
			`,
			'Confirm user deletion'
		).open().then( confirm => {
			if (confirm) {
				this.options.__player.ref.remove();
			}
		});
	}

	linkPlayer() {
		firebase.database().ref('users/').once('value')
		.then( __users => {
			new LinkPlayerModal(
				this.options.__player,
				__users
			).open().then( () => {
				
			});
		});
	}

	unlinkPlayer() {
		this.options.__player.ref.update({
			userId: null,
			photoURL: null
		});
	}*/

	/*onShow() {

	}*/
}

export default UserView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/users/user/user.view.js